const modules = {
	module: {
		id: 1,
		title: "Manage Modules"
	},
	user: {
		id: 2,
		title: "Manage Users"
	},
	role: {
		id: 3,
		title: "Manage User Roles"
	},
	moduleaccess: {
		id: 4,
		title: "Manage Role Accesses"
	},
	country: {
		id: 5,
		title: "Manage Countries"
	},
	state: {
		id: 6,
		title: "Manage States"
	},
	city: {
		id: 7,
		title: "Manage Cities"
	},
	// media: {
	// 	id: 8,
	// 	title: "Manage Media"
	// },
	panchayath: {
		id: 9,
		title: "Manage Panchayaths"
	},
	agent: {
		id: 10,
		title: "Manage LTP"
	},
	itemcategory: {
		id: 11,
		title: "Manage Item Categories"
	},
	item: {
		id: 12,
		title: "Manage Items"
	},
	customertype: {
		id: 13,
		title: "Manage Customer Types"
	},
	customer: {
		id: 14,
		title: "Manage Customers"
	},
	unit: {
		id: 15,
		title: "Manage Units"
	},
	tax: {
		id: 16,
		title: "Manage Taxes"
	},
	distributor: {
		id: 17,
		title: "Manage Head Offices"
	},
	retailer: {
		id: 18,
		title: "Manage Branches"
	},
	invoice: {
		id: 19,
		title: "Manage Proforma Invoice"
	},
	master: {
		id: 20,
		title: "Manage Masters"
	},
	brand: {
		id: 21,
		title: "Manage Brands"
	},
	brandaccess: {
		id: 22,
		title: "Manage Brand Accesses"
	},
	extradiscount: {
		id: 23,
		title: "Manage Extra Discounts"
	},
	district: {
		id: 24,
		title: "Manage Districts"
	},
	inventory: {
		id: 25,
		title: "Inventory Management"
	},
	warehouse: {
		id: 26,
		title: "Warehouse Management"
	},
	factory: {
		id: 27,
		title: "Factory Management"
	},
	rawmaterial: {
		id: 28,
		title: "Manage Raw Materials"
	},
	purchase: {
		id: 29,
		title: "Manage Purchase"
	},
	production: {
		id: 30,
		title: "Manage Production"
	},
	sale: {
		id: 31,
		title: "Manage Sales"
	},
	factorydispatch: {
		id: 32,
		title: "Manage Stock Dispatch"
	},
	stockmovement: {
		id: 33,
		title: "Manage Stock Movement"
	},
	return: {
		id: 34,
		title: "Manage Returns"
	},
	report: {
		id: 35,
		title: "Reports"
	},
	commission: {
		id: 36,
		title: "Manage Commission"
	},
	purchasereturn: {
		id: 37,
		title: "Purchase Return"
	},
	salereturn: {
		id: 38,
		title: "Sales Return"
	},
	retailersalereturn: {
		id: 39,
		title: "Branch Sales Return"
	},
	retailerpurchasereturn: {
		id: 40,
		title: "Branch Purchase Return"
	},
	rawmaterialstockreport: {
		id: 41,
		title: "Raw Material Stock"
	},
	factorystockreport: {
		id: 42,
		title: "Factory Material Stock"
	},
	warehousestockreport: {
		id: 43,
		title: "Warehouse Material Stock"
	},
	retailerstockreport: {
		id: 44,
		title: "Retailer Material Stock"
	},
	commissionreport: {
		id: 45,
		title: "Commission Report"
	},
	salesreport: {
		id: 46,
		title: "Sales Report"
	},
	itemreport: {
		id: 47,
		title: "Sales Report - Item Wise"
	},
}

export default modules
